import { User } from 'lucide-react'
import { useAuthStore } from '../../store/authStore'

export default function Header() {
  const { user } = useAuthStore()

  return (
    <header className="fixed top-0 left-0 right-0 h-12 bg-white border-b border-neutral-200 z-50">
      <div className="flex items-center justify-between h-full px-4">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-primary-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-semibold text-xs">GP</span>
          </div>
          <span className="font-medium text-neutral-900">
            Aelina <span className="text-neutral-400 font-normal">by GrowthPal</span>
          </span>
        </div>

        {/* Right section */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-neutral-100 rounded-full flex items-center justify-center">
            <User className="w-4 h-4 text-neutral-600" />
          </div>
        </div>
      </div>
    </header>
  )
}
